/**
 * What state one automation is in, and how its last month went (D9 — Allgemein).
 *
 * THE OLD "Übersicht", RE-CUT. Three facts are here and nothing else:
 *
 *   - the state, said as a sentence (`AutomationStatusCard`) — the header has
 *     the switch and the word, this tab says what that means;
 *   - the last run, as the server reports it (`last_run`);
 *   - the 30-day counts, exactly as the server counted them.
 *
 * WHAT MOVED OUT. "Auslöser" and "Ausführungsmodus" now live in their own tab,
 * because "how is this automation reached" is a question of its own and the
 * reference gives it one. The category moved into the header beside the name,
 * where it says what the automation IS on every tab. Nothing was dropped: each
 * value is shown once, in one place.
 *
 * `indeterminate` IS SHOWN SINCE D11b — as its own card ("Unklar") in the
 * statistics and as "Unklar" under "Letzte Ausführung", never as a failure
 * (E27, decided in D11b).
 *
 * `state_source` and `instance_slug` are still not rendered, for the reasons the
 * Übersicht recorded: migration bookkeeping and an always-empty slug are not the
 * reader's business.
 */
import React from "react";

import { formatDateTime } from "../../../utils/datetime";
import AutomationStatsCards from "./AutomationStatsCards";
import AutomationStatusCard from "./AutomationStatusCard";
import { AutomationIconTile, LAST_RUN_ICON } from "./automationIcons";
import { automationRunStatusLabel } from "./automationLabels";

function LastRunValue({ run }) {
  if (!run) return <span className="text-muted-foreground">Noch nie ausgeführt</span>;
  return (
    <span className="flex flex-col gap-0.5">
      <span>{formatDateTime(run.started_at)}</span>
      <span
        className={
          run.status === "failed"
            ? "text-[11.5px] text-destructive"
            : "text-[11.5px] text-muted-foreground"
        }
      >
        {automationRunStatusLabel(run.status)}
        {run.is_test ? " · Test" : ""}
      </span>
    </span>
  );
}

export default function AutomationGeneralTab({ automation }) {
  if (!automation) return null;

  return (
    <div className="flex flex-col gap-4">
      <AutomationStatusCard automation={automation} />

      <dl className="m-0 grid grid-cols-1 gap-2">
        <div className="flex items-start gap-2.5 rounded-[10px] border border-border bg-card px-3 py-2.5">
          <AutomationIconTile icon={LAST_RUN_ICON} tone="muted" size="sm" />
          <div className="flex min-w-0 flex-col gap-0.5">
            <dt className="text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground">
              Letzte Ausführung
            </dt>
            <dd className="m-0 text-[12.5px] text-foreground">
              <LastRunValue run={automation.last_run} />
            </dd>
          </div>
        </div>
      </dl>

      <AutomationStatsCards stats={automation.stats_30d} />
    </div>
  );
}
